import { styled } from '@mui/material/styles';

const P = styled('p')(() => ({
  fontSize: '1.125rem',
}));

export const Paragraph = ({ value }) => <P>{value || '입력이 필요합니다.'}</P>;
